document.addEventListener("DOMContentLoaded", async function () {
  let current_country_code = $("body").attr("data-country-code");
  const firstLetterCap = current_country_code.toUpperCase();

  if (sessionStorage.getItem("languageSelectedManually") === "true") {
    return;
  }

  try {
    const response = await fetch("https://ipinfo.io/json?token=e933f21d32e574");
    const data = await response.json();
    console.log(data);

    let countryCode = data.country;
    if (countryCode === "JP") {
      countryCode = "JA";
    }

    let redirectURL = null;
    const supportedLanguages = ["JA", "FR", "DE", "ES", "NO"];

    if (countryCode !== firstLetterCap) {
      switch (countryCode) {
        case "JA":
          redirectURL = "https://www.vr-wave.store/ja/";
          break;
        case "FR":
          redirectURL = "https://www.vr-wave.store/fr/";
          break;
        case "DE":
          redirectURL = "https://www.vr-wave.store/de/";
          break;
        case "ES":
          redirectURL = "https://www.vr-wave.store/es/";
          break;
        case "NO":
          redirectURL = "https://www.vr-wave.store/no/";
          break;
        default:
          if (localStorage.getItem("redirectedOnce") === "true") {
            return;
          }
          localStorage.setItem("redirectedOnce", "true");
          redirectURL = "https://www.vr-wave.store/";
          break;
      }
    }

    if (supportedLanguages.includes(countryCode)) {
      localStorage.removeItem("redirectedOnce");
    }

    if (redirectURL) {
      window.location.href = redirectURL;
    }
  } catch (error) {
    console.error("IPinfo error:", error);
  }
});

document.querySelectorAll(".lang_tab.ml_lang_texts_long").forEach(function (element) {
  element.addEventListener("click", function () {
    const value = this.getAttribute("value");
    console.log("Clicked value:", value);
    sessionStorage.setItem("languageSelectedManually", "true");
  });
});
